import {
    type interfaces,
    ContainerModule,
} from '@patsnap/tahiti-core/shared/inversify';

// Apis
import { ImageUploadApiImpl } from './apis/impls/image-upload-api';
import { BatchUploadImagesApi } from './apis/batch-upload-images-api';
import { SignFilesApi } from './apis/sign-files-api';

export const imageUploadModule = new ContainerModule((bind: interfaces.Bind) => {
    // Bind Apis
    bind(BatchUploadImagesApi).to(ImageUploadApiImpl);
    bind(SignFilesApi).to(ImageUploadApiImpl);
});

// Re-export types and constants
export * from './types';
export * from './constants';
export * from './apis/batch-upload-images-api';
export * from './apis/sign-files-api';
